import React from 'react';
import { Props } from '..';

const LfaCalendarIcon: React.FCC<Props> = ({ color = 'currentColor' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3333 22.6667C21.1743 22.6667 22.6667 21.1743 22.6667 19.3334C22.6667 17.4925 21.1743 16.0001 19.3333 16.0001C17.4924 16.0001 16 17.4925 16 19.3334C16 21.1743 17.4924 22.6667 19.3333 22.6667ZM19.3333 24.0001C21.9107 24.0001 24 21.9107 24 19.3334C24 16.7561 21.9107 14.6667 19.3333 14.6667C16.756 14.6667 14.6667 16.7561 14.6667 19.3334C14.6667 21.9107 16.756 24.0001 19.3333 24.0001Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3333 17C19.7015 17 20 17.2985 20 17.6667V19.0572L20.4714 19.5286C20.7317 19.7889 20.7317 20.2111 20.4714 20.4714C20.2111 20.7317 19.7889 20.7317 19.5286 20.4714L18.6667 19.6095V17.6667C18.6667 17.2985 18.9651 17 19.3333 17ZM5.33332 11.3333H3.99999V12.6667H5.33332V11.3333ZM3.99999 10C3.26359 10 2.66666 10.5969 2.66666 11.3333V12.6667C2.66666 13.4031 3.26359 14 3.99999 14H5.33332C6.06972 14 6.66666 13.4031 6.66666 12.6667V11.3333C6.66666 10.5969 6.06972 10 5.33332 10H3.99999ZM10.6667 11.3333H9.33332V12.6667H10.6667V11.3333ZM9.33332 10C8.59692 10 7.99999 10.5969 7.99999 11.3333V12.6667C7.99999 13.4031 8.59692 14 9.33332 14H10.6667C11.4031 14 12 13.4031 12 12.6667V11.3333C12 10.5969 11.4031 10 10.6667 10H9.33332ZM16 11.3333H14.6667V12.6667H16V11.3333ZM14.6667 10C13.9303 10 13.3333 10.5969 13.3333 11.3333V12.6667C13.3333 13.4031 13.9303 14 14.6667 14H16C16.7364 14 17.3333 13.4031 17.3333 12.6667V11.3333C17.3333 10.5969 16.7364 10 16 10H14.6667ZM5.33332 16.6667H3.99999V18H5.33332V16.6667ZM3.99999 15.3333C3.26359 15.3333 2.66666 15.9303 2.66666 16.6667V18C2.66666 18.7364 3.26359 19.3333 3.99999 19.3333H5.33332C6.06972 19.3333 6.66666 18.7364 6.66666 18V16.6667C6.66666 15.9303 6.06972 15.3333 5.33332 15.3333H3.99999ZM10.6667 16.6667H9.33332V18H10.6667V16.6667ZM9.33332 15.3333C8.59692 15.3333 7.99999 15.9303 7.99999 16.6667V18C7.99999 18.7364 8.59692 19.3333 9.33332 19.3333H10.6667C11.4031 19.3333 12 18.7364 12 18V16.6667C12 15.9303 11.4031 15.3333 10.6667 15.3333H9.33332Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33333 4C1.33333 3.6318 1.63181 3.33333 2 3.33333H5.33333V2H2C0.895433 2 0 2.8954 0 4V20C0 21.1046 0.895433 22 2 22H15.5031C15.2223 21.5973 15.0033 21.1483 14.8599 20.6667H2C1.63181 20.6667 1.33333 20.3682 1.33333 20V4ZM18.6667 14.7139C18.8844 14.6828 19.107 14.6667 19.3333 14.6667C19.5597 14.6667 19.7823 14.6828 20 14.7139V4C20 2.89547 19.1046 2 18 2H16V3.33333H18C18.3682 3.33333 18.6667 3.6318 18.6667 4V14.7139ZM6.66667 3.33333H13.7083V2H6.66667V3.33333Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 8.00008H1.33334V6.66675H20V8.00008Z"
      fill={color}
    />
    <path
      d="M4 0.666667C4 0.29848 4.29847 0 4.66667 0C5.03487 0 5.33333 0.29848 5.33333 0.666667V4C5.33333 4.3682 5.03487 4.66667 4.66667 4.66667C4.29847 4.66667 4 4.3682 4 4V0.666667ZM13.3333 0.666667C13.3333 0.29848 13.6318 0 14 0C14.3682 0 14.6667 0.29848 14.6667 0.666667V4C14.6667 4.3682 14.3682 4.66667 14 4.66667C13.6318 4.66667 13.3333 4.3682 13.3333 4V0.666667Z"
      fill={color}
    />
  </svg>
);

export default LfaCalendarIcon;
